import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const FIELDS = [['name', 'Business name', 'text'], ['phone', 'Phone', 'tel'], ['email', 'Email', 'email'], ['website', 'Website', 'url']];

export default function BusinessContactForm() {
  const { token } = useAuth();
  const headers = useMemo(() => ({ Authorization: `Bearer ${token}` }), [token]);
  const [f, setF] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { axios.get(`${API_URL}/api/admin/settings/business`, { headers }).then((r) => setF(r.data)).catch(() => setF(false)); }, [headers]);
  if (f === null) return <Loader2 className="h-5 w-5 animate-spin text-[#f36a19]" />;
  if (f === false) return <p className="text-sm text-[#a4471b]">Business details could not be loaded.</p>;
  const save = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      const r = await axios.put(`${API_URL}/api/admin/settings/business`, { name: f.name, phone: f.phone, email: f.email, website: f.website }, { headers });
      setF(r.data); toast.success('Business details saved');
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(Array.isArray(d) ? `Check the ${d[0]?.loc?.slice(-1)[0] || 'form'} field` : d || 'Could not save');
    } finally { setSaving(false); }
  };
  return (
    <section className="rounded-[10px] border border-[#e7e4db] bg-[#fffefa] p-6 sm:p-8 max-w-3xl" data-testid="business-contact-form">
      <form onSubmit={save}>
        <h2 className="text-2xl font-medium tracking-tight text-[#20211d]">Business contact details.</h2>
        <div className="grid sm:grid-cols-2 gap-x-5 gap-y-4 mt-6">
          {FIELDS.map(([k, l, t]) => (
            <label key={k} className="block">
              <span className="block text-[10px] tracking-[0.12em] font-bold text-[#7a7c6d] mb-1.5">{l.toUpperCase()}</span>
              <input type={t} required value={f[k] || ''} onChange={(e) => setF({ ...f, [k]: e.target.value })} maxLength={k === 'name' ? 150 : 200}
                className="h-11 w-full rounded-md border border-[#dcded2] bg-white px-3 text-sm focus:outline-none focus:ring-1 focus:ring-[#f36a19]" data-testid={`business-${k}`} />
            </label>
          ))}
        </div>
        <div className="flex flex-wrap items-center gap-4 mt-6">
          <button type="submit" disabled={saving} className="px-5 py-2.5 rounded-[5px] bg-[#f36a19] text-[#171912] text-sm font-bold inline-flex items-center gap-2" data-testid="business-save">{saving && <Loader2 className="h-4 w-4 animate-spin" />}Save</button>
          <p className="text-xs text-[#77776e]" data-testid="business-meta">{f.updated_at ? `Last saved by ${f.updated_by_name || 'an admin'}. ` : ''}Used inside the CRM. Public website content is not changed. Changes are recorded in the audit log.</p>
        </div>
      </form>
    </section>
  );
}
